export default __webpack_public_path__ + "static/media/WorkSans-SemiBold.8cad3c8f.ttf";